<template>
  <div class="w-full h-full card-container text-chplus-regular">
    <div class="master-container-content relative w-full h-full">
      <div class="flex flex-col h-full">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutCard"
};
</script>

<style scoped>
.master-container-content {
  padding: 1.624rem 0.84rem;
}

@media (min-width: 768px) {
  .master-container-content {
    padding: 1.856rem 2.16rem;
  }
}
</style>
